import Box from '../kit/box'
import Card from '../kit/card'
import { colors } from '@theme'
import React from 'react'

type ColorsKeys = keyof typeof colors

type PostItCardVariant =
  | 'default'
  | 'disabled'
  | 'enabled'
  | 'activated'
  | 'answered'
  | 'rejected'

type PostItCardVariantProps = {
  [key in PostItCardVariant]: {
    backgroundColor: ColorsKeys
    borderColor: ColorsKeys
  }
}

const PostItCardVariants: PostItCardVariantProps = {
  default: {
    backgroundColor: 'white',
    borderColor: 'walrusBlue500'
  },
  disabled: {
    backgroundColor: 'white',
    borderColor: 'walrusNeutral700'
  },
  enabled: {
    backgroundColor: 'white',
    borderColor: 'paleGreen'
  },
  activated: {
    backgroundColor: 'lightGreen02',
    borderColor: 'paleGreen'
  },
  answered: {
    backgroundColor: 'lightGreen03',
    borderColor: 'paleGreen'
  },
  rejected: {
    backgroundColor: 'walrusRed200',
    borderColor: 'pink'
  }
}

interface PostItCardProps {
  variant: PostItCardVariant
  children: React.ReactNode
}

const PostItCard: React.FC<PostItCardProps> = ({ variant, children }) => {
  const { backgroundColor, borderColor } = PostItCardVariants[variant]

  return (
    <Card backgroundColor={backgroundColor} padding='16'>
      <Box
        position='absolute'
        top={0}
        left={0}
        backgroundColor={borderColor}
        width='4px'
        height='100%'
      />
      {children}
    </Card>
  )
}

export default PostItCard
